import React, { useEffect, useState } from 'react'
import MySelect from '../../UI/form/MySelect'

const AgreeSelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

	// console.log('forciblyValue', forciblyValue)

  	const [value, setValue] = useState(
		forciblyValue && forciblyValue === true ? 'yes' :
		forciblyValue === false ? 'no' : forciblyValue
	)
  	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: 'yes',
			name: 'Погоджено'
		},
		{
			id: 'no',
			name: 'Не погоджено'
		},
		{
			id: 'clear',
			name: 'Очистити'
		},
	])

	// useEffect(() => {
	// 	getUnitMeasures()
	// }, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getUnitMeasures = () => {
		// getGoodTypesAllAPI().then(data => {
		// 	setGoodTypes(data)
		// }).catch(e => {
		// 	// setError(responseError(e))
		// 	console.error(responseError(e))
		// })
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Погодити?"
        labelId="select__agree-label"
        id='select__agree'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Погодити?'
        // sx={{width: '200px'}}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default AgreeSelectMain